module.exports = __webpack_public_path__ + "static/media/login_banner.3756e3eb.png";